<template>
    <div>
        <div class="main-wrapper">
            <!--begin::sidebar-->
            <sidebar-component classMenu="ListLumpsum"></sidebar-component>
            <!--end::sidebar-->

            <div class="page-wrapper">
                <!--begin::navbar-->
                <navbar-component></navbar-component>
                <!--end::navbar-->

                <!--begin::content-->
                <div class="page-content">
                    <div class="
                d-flex
                justify-content-between
                align-items-center
                flex-wrap
                grid-margin
              ">
                        <div>
                            <h4 class="mb-12 mb-md-0"></h4>
                        </div>

                        <div class="col-lg-12 col-xl-12 stretch-card">
                            <div class="card">
                                <div class="card-header d-flex justify-content-between align-items-center">
                                    <div class="d-flex align-items-center">
                                        <button  class="btn btn-primary btn-sm me-2"
                                            @click.prevent="backForm()">
                                            Back
                                        </button>

                                        <h4 class="mb-0">List Detail Lumpsum</h4>
                                    </div>

                                    <button v-if="permision_role.method_custom2" class="btn btn-success btn-sm"
                                        @click.prevent="createData()">
                                        <i class="link-icon" data-feather="plus"></i>
                                        {{ $t("createNew") }}
                                    </button>
                                </div>


                                <div class="card-body">
                                    <div class="row">
                                        <div class="mb-1 d-flex">
                                            <div style="width: 120px;">Company Code</div>
                                            <div class="me-2">:</div>
                                            <div>{{ rows.customer_code }}</div>
                                        </div>

                                        <div class="mb-1 d-flex">
                                            <div style="width: 120px;">Company Name</div>
                                            <div class="me-2">:</div>
                                            <div>{{ rows.customer_name }}</div>
                                        </div>

                                        <div class="mb-1 d-flex">
                                            <div style="width: 120px;">SAP Code</div>
                                            <div class="me-2">:</div>
                                            <div>{{ rows.sap_code }}</div>
                                        </div>


                                    </div>
                                    <vue-good-table title="list-region" mode="remote" @on-page-change="onPageChange"
                                        @on-sort-change="onSortChange" @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange" :totalRows="totalRecords"
                                        :line-numbers="true" :isLoading.sync="isLoading" :pagination-options="{
                                            enabled: true,
                                        }" :rows="rowsDetail" :columns="columns">
                                        <template slot="table-row" slot-scope="props">
                                            <span v-if="props.column.field == 'actions'">

                                                <a href="#" title="Detail"
                                                    @click.prevent="detailData(props.index, props.row)">
                                                    <i class="mdi mdi-eye" style="font-size: 16px"></i>
                                                </a>
                                                <a href="#" v-if="props.row.kalkulasi != null" title="Download"
                                                    @click.prevent="downloadData(props.index, props.row)">
                                                    <i class="mdi mdi-download" style="font-size: 16px"></i>
                                                </a>

                                                <span v-if="user_type=='CT'">

                                                        <a href="#" v-if="props.row.kalkulasi != null && props.row.status!='Send To Billing' && props.row.status!='Send To SAP'" title="Send "
                                                            @click.prevent="sendDataToBilling(props.index, props.row,'Send To Billing')">
                                                            <i class="mdi mdi-send" style="font-size: 16px"></i>
                                                        </a>

                                                        <a href="#" v-if="props.row.kalkulasi != null && props.row.status!='Send To Billing' && props.row.status=='Send To SAP'" title="Send "
                                                            @click.prevent="sendDataToBilling(props.index, props.row,'Send Status Back To Calculate ')">
                                                            <i class="mdi mdi-send" style="font-size: 16px"></i>
                                                        </a>


                                                </span>

                                                  <span v-if="user_type=='CHAIN'">

                                                        <a href="#" v-if="props.row.kalkulasi != null && props.row.status=='Send To Billing'" title="Send "
                                                            @click.prevent="sendDataToBilling(props.index, props.row,'Send To Billing')">
                                                            <i class="mdi mdi-send" style="font-size: 16px"></i>
                                                        </a>

                                                        <!-- <a href="#" v-if="props.row.kalkulasi != null && props.row.status=='Send To SAP'" title="Send "
                                                            @click.prevent="sendDataToBilling(props.index, props.row,'Send To SAP')">
                                                            <i class="mdi mdi-send" style="font-size: 16px"></i>
                                                        </a> -->

                                                      

                                                </span>
                                                
                                            </span>

                                            <span v-else-if="props.column.field == 'contract_rate'">
                                                {{ formatNumber(props.formattedRow[props.column.field]) }}
                                            </span>

                                            <span v-else>
                                                {{ props.formattedRow[props.column.field] }}
                                            </span>


                                        </template>
                                    </vue-good-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--end::content-->
                <modal-add-detail-lumpsum :showModal="showModal" :data="this.dataModal" @closeModal="closeMyModal">

                </modal-add-detail-lumpsum>

                <modal-calculate-lumpsum :showModal="showModalCalculate" :sap_code="rows.sap_code"
                    :data="this.dataModalCalculate" @closeModal="closeMyModal">

                </modal-calculate-lumpsum>

                <!--begin::footer-->
                <footer-component></footer-component>
                <!--end::footer-->
            </div>
        </div>
    </div>
</template>

<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import modalAddDetailLumpsum from "@/components/modal/modalAddDetailLumpsum.vue";
import modalCalculateLumpsum from "@/components/modal/modalCalculateLumpsum.vue";
export default {
    name: "LumpsumDetailIndex",
    components: {
        "sidebar-component": sidebarComponent,
        "navbar-component": navbarComponent,
        "footer-component": footerComponent,
        "modal-calculate-lumpsum": modalCalculateLumpsum,
        "modal-add-detail-lumpsum": modalAddDetailLumpsum,
    },

    data() {
        return {
            company_code:"",
            showModal: false,
            dataModal: {},
            user_type:"",
            showModalCalculate: false,
            dataModalCalculate: {},
            maxToasts: 100,
            position: "up right",
            closeBtn: true,
            isLoading: false,
            errors: [],
            permision_role: [],
            langs: ["id", "en"],
            detailUser: [],
            detailDivisi: [],
            totalRecords: 0,
            serverParams: {
                columnFilters: {},
                sort: {
                    field: "",
                    type: "",
                },
                page: 1,
                per_page: 10,
            },
            columns: [
                {
                    label: "Action",
                    field: "actions",
                    sortable: false,
                },
                {
                    label: 'Status',
                    field: "status",
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Filter By ", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: 'Periode',
                    field: "periode",
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Filter By ", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: 'Billable Method',
                    field: "billable_method",
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Filter By ", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },

                {
                    label: 'SKU',
                    field: "sku",
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Filter By ", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },

                {
                    label: 'Jumlah Truck',
                    field: "JumlahTruck",
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Filter By ", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },


                {
                    label: 'Max Trip',
                    field: "max_trip",
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Filter By ", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },


                {
                    label: 'Rate',
                    field: "contract_rate",
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Filter By ", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },













            ],
            rows: [],
            rowsDetail: [],
        };
    },
    watch: {},
    methods: {

        formatNumber(value) {
            //console.log(value);
            return parseInt(value).toLocaleString();
        },
        downloadData(index, row) {
            console.log(index);
            const baseURI = this.$settings.endPoint + `lumpsum-rental/list-lumpsum/output/${row.rm_billable_rate_detail_lumpsum_report_header_id}?send=no`;
            const CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
            //const file_name = "download_" + CurrentDate + ".xls"; // Sesuaikan jika memang .xls

            return this.$http
                .post(
                    baseURI,
                    {}, // Jika tidak ada payload, berikan objek kosong
                    {
                        responseType: "blob", // responseType diletakkan di parameter ketiga
                    }
                )
                .then((response) => {
                    console.log("Response data type:", response.data.constructor.name); // Harusnya 'Blob'
                    console.log("Response headers:", response.headers);

                    const contentType = response.headers["content-type"];
                    const extension = contentType.includes("spreadsheetml") ? "xlsx" : "xls";
                    const blob = new Blob([response.data], { type: contentType });

                    const fileURL = URL.createObjectURL(blob);
                    const fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", `download_${CurrentDate}.${extension}`);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    fileLink.remove();
                    URL.revokeObjectURL(fileURL);
                })
                .catch((error) => {
                    console.error("Download error:", error);
                });
        },


        // downloadData() {
        //   this.fade(true);
        //   var baseURI = this.$settings.endPoint + "/user/download";
        //   var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
        //   var columnFilters = this.serverParams.columnFilters;
        //   var role = columnFilters["role.name"];
        //   var region_code = columnFilters["region_detail.code"];

        //   var sendData = {
        //     username: this.serverParams.columnFilters.username,
        //     name: this.serverParams.columnFilters.name,
        //     email: this.serverParams.columnFilters.email,
        //     level: this.serverParams.columnFilters.level,
        //     status: this.serverParams.columnFilters.status,
        //     role:role,
        //     region_code: region_code,
        //     file_name: "download_" + CurrentDate + ".xlsx",
        //   };
        //   this.$http({
        //     url: baseURI,
        //     method: "GET",
        //     data: sendData,
        //     responseType: "blob",
        //   })
        //     .then((response) => {
        //       this.errors = [];
        //       var filename = sendData.file_name;

        //       var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        //       var fileLink = document.createElement("a");

        //       fileLink.href = fileURL;
        //       fileLink.setAttribute("download", filename);
        //       document.body.appendChild(fileLink);
        //       fileLink.click();
        //       this.fade(false);
        //     })
        //     .catch((error) => {
        //       if (error.response) {
        //         if (error.response.status === 422) {
        //           this.errors = { message: ["File Not Found"] };
        //           this.error("File Not Found");
        //         } else if (error.response.status === 500) {
        //           this.$router.push("/server-error");
        //         } else {
        //           this.$router.push("/page-not-found");
        //         }
        //       }
        //     });
        // },
        createData() {
            this.showModal = true;
            this.dataModal = this.rows;
        },

        uploadData() {
            window.location.href = "/master-bbm/upload";
        },

        editData(index, row) {
            var params = this.$onRandom(row.rm_billable_rate_header_id);
            window.location.href = "/master-bbm/edit/" + params;
        },

        detailData(index, row) {
            this.showModalCalculate = true;
            this.dataModalCalculate = row;
            console.log(row);
            // var params = this.$onRandom(row.rm_fuel_master_id);
            // window.location.href = "/rental-lumpsum/list/" + params;
        },



        backForm() {
            this.$router.push({ name: 'LumpsumIndex' });
        },

        closeMyModal() {
            this.showModal = false;
            this.showModalCalculate = false;
            this.dataModal = {}
            this.loadItems();
        },

        sendDataToBilling(index, row, title) {
            this.$swal({
                title: this.$t("areYouSure"),
                text: `${title} ?`,
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
            }).then((result) => {
                if (result.value) {
                    console.log(index);
                    console.log(row);
                    console.log(status);

                    var formData = "";

                    if(this.user_type=='CT'){
                        formData = {
                        "send": "Send To Billing"
                        };
                    }

                    const baseURI =
                        this.$settings.endPoint + `lumpsum-rental/list-lumpsum/output/${row.rm_billable_rate_detail_lumpsum_report_header_id}?send=yes`;
                    this.$http
                        .post(baseURI, formData
                    
                    )
                        .then((response) => {
                            this.loading();
                            if (response.data.status === 200) {
                                this.success(response.data.datas.messages);
                                this.loadItems();
                            } else {
                                this.errors = response.data.errors;
                                this.resultError(response.data.errors);
                            }
                        })
                        .catch((error) => {
                            this.loading();
                            if (error.response) {
                                if (error.response.status === 422) {
                                    this.errors = error.response.data.errors;
                                    this.resultError(error.response.data.errors);
                                } else if (error.response.status === 500) {
                                    this.$router.push("/server-error");
                                } else {
                                    this.$router.push("/page-not-found");
                                }
                            }
                        });
                }
            });
        },

        calculate() {
            this.$swal({
                title: "Apakah Anda Yakin akan mengkalkulasi BBM ?",
                text: "Semua Record Payable dan Billable akan mengalami kenaikan sesuai dengan exponensial kenaikan harga BBM ini",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
            }).then((result) => {
                console.log(result);
            });
        },
        // load items is what brings back the rows from server
        loadItems() {

            const userDatas = this.$getUserInfo();
            this.user_type = userDatas.sub.user_type;

            var params = this.$onBehind(this.$route.params.id);
            let baseURI=this.$settings.endPoint + "lumpsum-rental/list-lumpsum/" + params[0];
            if(this.user_type=='CT'){
                baseURI = this.$settings.endPoint + "lumpsum-rental/list-lumpsum-ops/" + params[0];
            }
            console.log(this.user_type);
            console.log(baseURI);
            return this.$http
                .get(
                    baseURI +
                    `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field=='JumlahTruck'? 'jumlah_truck' : this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&periode=${this.serverParams.columnFilters.periode}&billable_method=${this.serverParams.columnFilters.billable_method}&sku=${this.serverParams.columnFilters.sku}&contract_rate=${this.serverParams.columnFilters.contract_rate}&status=${this.serverParams.columnFilters.status}`,
                )
                .then((response) => {
                    this.rows = response.data.datas;
                    this.rowsDetail = response.data.datas.rows;
                    this.totalRecords = response.data.datas.total;
                });
        },

        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
            this.loadItems();
        },

        onColumnFilter(params) {
            params.page = 1;
            this.updateParams(params);
        },

        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
        },

        onSortChange(params) {
            this.updateParams({
                sort: {
                    type: params[0].type,
                    field: params[0].field,
                },
            });
        },

        onPerPageChange(params) {
            this.updateParams({ per_page: params.currentPerPage });
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },


        //ini function button
        filterSearch() {

            const periodCodeFilterElement = document.querySelector('[name="vgt-period_code"]'); //ini setiap field pasti ada vgt-

            const periodNameFilterElement = document.querySelector('[name="vgt-period_name"]'); //ini setiap field pasti ada vgt-

            var params = {
                "columnFilters": {
                    "period_code": periodCodeFilterElement.value,
                    "period_name": periodNameFilterElement.value,
                    "price": '',
                    "price_gap": '',
                    "effective_date": '',
                    "expired_date": '',
                },
                "page": 1
            } // params yang di kirim

            this.updateParams(params)//ini untuk update params vue good table
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.isLoading = false;
            }, 1000); // hide the message after 3 seconds
        },

        fetchIt() {
            const userDatas = this.$getUserInfo();
            this.detailUser = userDatas.sub;
            this.company_code = userDatas.sub.company_detail.code;
            this.user_type = userDatas.sub.user_type;
            console.log(this.user_type);
            // this.permision_role = userDatas.sub.permision_role;
            let rolePermision = [];
            userDatas.sub.permision_role.forEach(function (permision) {
                if (permision.permission.controller == "RmLumpsumReportController") {
                    rolePermision = permision;
                    // console.log(permision);
                }
            });


            this.permision_role = rolePermision;
        },

        logout() {
            this.$logoutUser();
            this.$router.push("/");
        },
    },
    events: {},
    created: function () { },
    mounted() {
        this.fetchIt();
        this.loading();


    },
};
</script>
<style scoped></style>